module.exports = __webpack_public_path__ + "img/2-4.012180e5.jpg";